<i18n
  src="@/locales/views/customer/query/basic_containers/show_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<template>
  <div>
    <go-back-link
      :text="$t('labels.go-back-link')"
      name="customer_query_basic_containers_list_containers_path"
      :params="{
        customer_id: customer_id,
        agro_exporter_id: agro_exporter_id
      }"
    />

    <bread-crumbs :labels="[module_name, agro_exporter?.name]"></bread-crumbs>

    <div class="mt-8" v-if="load_data_general">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200" v-if="container">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.container_code") }}
                </dt>
                <dd class="content-data">
                  {{ container.container_code }}
                </dd>
              </div>
              <div class="sm:col-span-3"></div>
            </div>
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <div class="sm:col-span-3">
                  <dt class="label-data">
                    <template v-if="(container.exportation.exportation_type_id == 0)">
                      {{ $t("model.exportation.booking_code_0") }}
                    </template>
                    <template v-else-if="(container.exportation.exportation_type_id == 1)">
                      {{ $t("model.exportation.booking_code_1") }}
                    </template>
                  </dt>
                  <dd class="content-data">
                    <exportation-type :exportation_type_id="container.exportation?.exportation_type_id" only_icon="true"/><span class="icon-space"></span>{{ container.exportation?.booking_code }}
                  </dd>
                </div>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.status") }}
                </dt>
                <dd class="content-data">
                  <exportation-status
                    :status_id="container.exportation?.status_id"
                  />
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.origin_export") }}
                </dt>
                <dd class="content-data">
                  {{ container.exportation?.origin_export?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.destination_export") }}
                </dt>
                <dd class="content-data">
                  {{ container.exportation?.destination_export?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.departured_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(container.exportation?.departured_at) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.arrived_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(container.exportation?.arrived_at) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.shipping_line") }}
                </dt>
                <dd class="content-data">
                  {{ container.exportation?.shipping_line?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.ship") }}
                </dt>
                <dd class="content-data">
                  {{ container.exportation?.ship }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.packing_house") }}
                </dt>
                <dd class="content-data">
                  {{ container.packing_house_names.join(", ") }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.load_date") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(container.load_date) }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <dt class="label-data">
                  {{ $t("model.container.comments") }}
                </dt>
                <dd class="content-data">
                  {{ container.comments }}
                </dd>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-else>
      <loading-message />
    </template>

    <div v-if="any_package_group_or_files"  class="mt-8">
      <tabs-container v-model="option_tabs" />
      <pallets-tab
        v-if="this.option_tabs[0].current"
        v-model:container="container"
        v-model:package_groups="package_groups"
        :customer_id="customer_id"
      ></pallets-tab>
      <packages-tab
        v-if="this.option_tabs[1].current"
        v-model:package_groups="package_groups"
      />
      <files
        v-if="this.option_tabs[2].current"
        v-model:container="container"
        :customer_id="customer_id"
      />
    </div>
  </div>
</template>

<script>
import Requester from "@/views/customer/requesters/query/basic_containers/show_container.js";
import PalletsTab from "@/components/views/customer/query/basic_containers/show_container/tabs/Pallets.vue";
import PackagesTab from "@/components/views/customer/query/basic_containers/show_container/tabs/Packages.vue";
import Files from "@/components/views/customer/query/basic_containers/show_container/tabs/Files.vue";
import ExportationStatus from "@/components/views/agro_exporter/production/shared/exportation/ExportationStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";

export default {
  name: "CustomerQueryBasicContainersShowContainer",
  components: {
    Files,
    PalletsTab,
    PackagesTab,
    ExportationStatus,
    ExportationType
  },
  props: ["customer_id", "agro_exporter_id", "container_id"],
  data() {
    return {
      container: null,
      agro_exporter: null,
      agro_exporter_process: null,
      option_tabs: [
        {
          name: this.$t("labels.title_package_groups"),
          current: false,
          icon: "fa-solid fa-pallet-boxes"
        },
        {
          name: this.$t("labels.title_packages"),
          current: false,
          icon: "fa-solid fa-user"
        },
        {
          name: this.$t("labels.title_attachments"),
          current: false,
          icon: "fa-solid fa-file"
        }
      ],
      load_data_general: false
    };
  },
  methods: {
    fetchAgroExporter: async function () {
      const response = await Requester.fetchAgroExporter(
        this.customer_id,
        this.agro_exporter_id
      );
      this.agro_exporter = response.data;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer(
        this.customer_id,
        this.agro_exporter_id,
        this.container_id
      );

      this.container = response.data;

      if(this.container.package_groups.length > 0){
        this.option_tabs[0].current = true
      }else{
        this.option_tabs[2].current = true
      }
      this.load_data_general = true;
    },
    getPackageGroup: function (row, col) {
      return this.package_groups.find(
        package_group =>
          package_group.row_position === row &&
          package_group.col_position === col
      );
    }
  },
  computed: {
    package_groups: function () {
      return this.container?.package_groups ?? [];
    },
    any_package_group_or_files: function () {
      return (this.package_groups?.length > 0 || this.container?.container_attachments.length > 0);
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchAgroExporter();
        this.fetchContainer();
      })
    );
  }
};
</script>
